import { portfolioData } from '../../data/portfolioData';
import './About.css';

const About = () => {
  const { about, personalInfo } = portfolioData;

  return (
    <section id="about" className="about section-bg">
      <div className="container">
        <h2>About Me</h2>
        <div className="about-content">
          <div className="about-text">
            <p>{about.description}</p>
            
            <div className="about-highlights">
              <h3>Key Highlights</h3>
              <ul>
                {about.highlights.map((highlight, index) => (
                  <li key={index}>{highlight}</li>
                ))}
              </ul>
            </div>
            
            <div className="personal-info">
              <h3>Personal Information</h3>
              <div className="info-grid">
                <div className="info-item">
                  <strong>Location:</strong>
                  <span>{personalInfo.location}</span>
                </div>
                <div className="info-item">
                  <strong>Email:</strong>
                  <span>{personalInfo.email}</span>
                </div>
                <div className="info-item">
                  <strong>Phone:</strong>
                  <span>{personalInfo.phone}</span>
                </div>
                <div className="info-item">
                  <strong>Driver's License:</strong>
                  <span>{personalInfo.driversLicense}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;